import axios, { AxiosRequestConfig } from 'axios';
import { clearSessionCredentials } from '../../globalFunctions';
import { NavigateFunction } from 'react-router-dom';
import { Exercise } from '../../types';

export const saveExercise = async (token: string,exercise  ,navigate: NavigateFunction) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/exercise`, exercise,
            requestConfig
        );

        console.log(response)

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao buscar status dos módulos',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
            clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return false;
        }
    }
};


export const importBatch = async (token: string, exercisesPayload: any[], navigate: NavigateFunction) => {
  try {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/exercise/batch`,
      { exercises: exercisesPayload },
      requestConfig
    );

    return response.data;
  } catch (error: any) {
    // proteções caso error.response não esteja definido
    const status = error?.response?.status;
    if ([401, 419].includes(status)) {
      clearSessionCredentials(navigate);
      return false;
    }

    console.error('Erro ao executar importBatch', error?.response?.data || error);
    return false;
  }
};


export const destroyExercise = async (token: string,id : number  ,navigate: NavigateFunction) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/exercise/`+id,
            requestConfig
        );

        return true;
    } catch (error: any) {
        console.log(error)
        return false

    }
};


export const destroyModule = async (token: string,id : number  ,navigate: NavigateFunction) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/module/`+id,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        console.log(error)
        return false

    }
};

export const createModule = async (
  token: string,
  name: string,
  modal: string,
  sort: number,
  image: string,
) => {
  try {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    };

    // Monta os dados no formato de objeto
    const data = {
      name: name,
      modal: modal,
      sort: sort,
      image: image
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/module`,
      data,
      requestConfig
    );

    return response.data;
  } catch (error: any) {
    console.error("Erro ao criar módulo:", error);
    return false;
  }
};

export const updateModule = async (
  token: string,
  name: string,
  modal: string,
  id: number,
  sort: number,
  image: string
) => {
  try {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    };

    // Monta os dados no formato de objeto
    const data = {
      name: name,
      modal: modal,
      sort: sort,
      id: id,
      image: image
    };

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/module/${id}`,
      data,
      requestConfig
    );

    return response.data;
  } catch (error: any) {
    console.error("Erro ao criar módulo:", error);
    return false;
  }
};


export const saveExerciseChanges = async (
    token: string,
    exercise: Exercise,
    navigate: NavigateFunction
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/exercise/${exercise.id}`,
            exercise,
            requestConfig
        );

        return true;
    } catch (error: any) {
        const response = {
            message: 'Erro ao salvar alterações dos exercícios',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
           // clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return false;
        }
    }
};


export const getModuleJogadasBySlug = async (
    token: string,
    slug: string,
    navigate: NavigateFunction
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/module/jogadas/${slug}`,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao salvar alterações dos exercícios',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
           // clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return false;
        }
    }
};